import { Button, Card, Col, Icon, Row } from '@elotech/components';
import {
  faApple,
  faFacebookSquare,
  faGoogle
} from '@fortawesome/free-brands-svg-icons';
import { faKey } from '@fortawesome/free-solid-svg-icons';
import { Props as FAIconProps } from '@fortawesome/react-fontawesome';
import { Provider, ProviderAssociado } from 'itbi-common/type';
import React from 'react';
import styled from 'styled-components';

import logoIsseMaringa from './ecity.png';
import { ReactComponent as Govbr } from './govbrColor.svg';
import { ReactComponent as IcpBrasil } from './icp-brasil-icon.svg';
import { ReactComponent as Microsoft } from './microsoft-icon.svg';

type Props = {
  provider: Provider;
  providerAssociado?: ProviderAssociado;
  onAddProvider?: (provider: Provider) => void;
  onRemoveProvider: (provider: Provider) => void;
};

const GovBrNivelColor = {
  1: '#ad8a56',
  2: '#b4b4b4',
  3: '#c9b037'
};

const LogoIsseMaringa: React.FC = () => (
  <img
    src={logoIsseMaringa}
    alt="Acesso Cidadão"
    title="Acesso Cidadão"
    width="48px"
    height="48px"
    style={{ paddingTop: '3px', paddingBottom: '3px' }}
  />
);

const StyledIcon = styled((props: FAIconProps & { iconColor?: string }) => (
  <Icon {...props} color={props.iconColor} />
))<{ iconColor: string }>`
  & > * {
    fill: ${props => props.iconColor};
  }
`;

const brandIcons = {
  apple: (
    <StyledIcon
      icon={faApple}
      iconColor={'#D0D2D4'}
      size={'4x'}
      title={'Apple'}
    />
  ),
  facebook: (
    <StyledIcon
      icon={faFacebookSquare}
      iconColor={'#3b5998'}
      size={'4x'}
      title={'Facebook'}
    />
  ),
  google: (
    <StyledIcon
      iconColor={'#de5246'}
      icon={faGoogle}
      size={'4x'}
      title={'Google'}
    />
  ),
  microsoft: (
    <Microsoft
      width="36.75px"
      height="42px"
      style={{ paddingTop: '3px', paddingBottom: '3px' }}
    />
  ),
  certificate: (
    <IcpBrasil
      width="36.75px"
      height="42px"
      style={{ paddingTop: '3px', paddingBottom: '3px' }}
    />
  ),
  govbr: (
    <Govbr
      width="100px"
      height="42px"
      style={{ paddingTop: '3px', paddingBottom: '3px' }}
    />
  ),
  'isse-teste': <LogoIsseMaringa />,
  'isse-maringa': <LogoIsseMaringa />
};

const ProviderCard: React.FC<Props> = ({
  provider,
  providerAssociado,
  onAddProvider,
  onRemoveProvider
}) => {
  const isAssociated = providerAssociado !== undefined;

  if (!provider.visible && !isAssociated) {
    return null;
  }
  return (
    <Col md={3} sm={4} xs={6}>
      <Card>
        <div style={{ height: '150px' }}>
          <Row className={'center mb-xs'} style={{ wordWrap: 'break-word' }}>
            {brandIcons[provider.provider] ?? (
              <StyledIcon
                icon={faKey}
                iconColor={'grey'}
                size={'4x'}
                title={provider.provider}
              />
            )}
          </Row>
          <Row className={'center'}>
            {providerAssociado
              ? providerAssociado.username
              : 'Nenhuma conta vinculada'}
            {providerAssociado && providerAssociado.govBRNivel && (
              <>
                <span> - </span>
                <span
                  style={{
                    fontWeight: 'bold',
                    color: GovBrNivelColor[providerAssociado.govBRNivel.id]
                  }}
                >
                  Nível {providerAssociado.govBRNivel.descricao}
                </span>
              </>
            )}
          </Row>
          <Row>
            {isAssociated ? (
              <Button
                className={'center mt-xs'}
                onClick={() => onRemoveProvider(provider)}
              >
                Desconectar
              </Button>
            ) : !!onAddProvider ? (
              <Button
                className={'center mt-xs'}
                onClick={() => onAddProvider(provider)}
              >
                Conectar
              </Button>
            ) : null}
          </Row>
        </div>
      </Card>
    </Col>
  );
};

export default ProviderCard;
